/* eslint-disable no-unused-vars */

import React, { Component } from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toast, Accordion, Card } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from 'moment';
import CountdownBanner from './Components/CountdownBanner';

var getParams = function (url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};


class Challenge extends React.Component {
    constructor(props) {
        super();
        this.state = {
            apiUrl: window.$apiUrl,
            currentChallenge: "",
            storyRedirect: false,
            storyRedirectID: "",
            winnerFilter: 16,
            filterProject: 16,
            StoryList: [],
            WinnerList: [],
            ChallengeList: [],
            ThemeList: [],
            alertBox: false,
            scrollToVote: false,
            currentPage: 1,
            noMoreTheme: false
        };

        this.ViewMore = this.ViewMore.bind(this);
        this.getTheme = this.getTheme.bind(this);
        this.vote = this.vote.bind(this);
        this.ChangeProject = this.ChangeProject.bind(this);
        this.getLatestChallenge = this.getLatestChallenge.bind(this);
        this.toggleAlertBox = this.toggleAlertBox.bind(this);

        this.currentParticipants = React.createRef();
    }

    toggleAlertBox() {
        this.setState({ alertBox: !this.state.alertBox });
    }

    Challenge_IsValidVotingPeriod() {
        fetch(this.state.apiUrl + '/ChallengeApi/IsValidVotingPeriod', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((data) => {
                if (data === 'OK') {
                    this.setState({ isVotingPeriod: true });
                } else {
                    this.setState({ isVotingPeriod: false });
                }
            })
            .catch(console.log);
    }

    ViewMore() {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;
        this.setState({ currentPage: currentPage });
        this.getThemeList(currentPage);
    }

    vote(e, sid) {
        e.target.disabled = true;
        var votecount = localStorage.getItem('vcount') ? JSON.parse(localStorage.getItem('vcount')) : [];
        fetch(this.state.apiUrl + '/CommonAPI/SubmitVote', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify(
                {
                    "Story_ID": sid

                }
            )
        })
            .then(res => res.json())
            .then((data) => {
                votecount.push(sid);
                this.setState({ alertBox: true });
                localStorage.setItem('vcount', JSON.stringify(votecount));
            })
            .catch(console.log);
    }

    getLatestChallenge(filterValue) {

        fetch(this.state.apiUrl + '/ChallengeAPI/GetLatestChallenge', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ currentChallenge: data });
                    this.getStoryList(this.state.filterProject, data.Challenge_ID);
                    fetch(this.state.apiUrl + '/StoryAPI/GetStoryWinner', {
                        method: 'POST',
                        headers: {
                            'token': process.env.REACT_APP_API_TOKEN,
                            'Content-Type': 'application/json; charset=utf-8',
                            'access-control-allow-origin': '*'
                        },
                        body: JSON.stringify({
                            "Challenge_ID": data.Challenge_ID,
                            "Country_ID": null,
                            "Project_ID": filterValue ? filterValue : 16,
                            "School_ID": null,
                            "Is_Feature": null,
                            "Story_Title": null
                        })
                    })
                        .then(res => res.json())
                        .then((winner_data) => {
                            var getfilterValue = filterValue;
                            if (winner_data.Status === 'OK') {
                                this.setState({ WinnerList: winner_data.StoryDetail, winnerFilter: getfilterValue });
                            } else {
                                this.setState({ WinnerList: [], winnerFilter: getfilterValue });
                            }
                        })
                        .catch(console.log);
                }
            })
            .catch(console.log);
    }

    ChangeProject(pid) {
        this.getStoryList(pid, this.state.currentChallenge.Challenge_ID);
        this.setState({ filterProject: pid });
    }

    getStoryList(project, challengeID) {
        fetch(this.state.apiUrl + '/StoryAPI/GetStoryList', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "Start_Index": 1,
                "Max_Rows": 1000,
                "Project_ID": project,
                "Status": 1,
                "Is_Publish": 1,
                "Challenge_ID": challengeID
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ StoryList: data.StoryDetail });
                } else {
                    this.setState({ StoryList: [] });
                }
            })
            .catch(console.log);


    }

    getChallenge() {
        fetch(this.state.apiUrl + '/ChallengeAPI/GetChallengeList', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify(
                {
                    "Challenge_ID": null,
                    "Start_Index": 1,
                    "Max_Rows": 30,
                    "Challenge_Title": null,
                    "Sort_Value": null,
                    "Is_Ongoing": 0
                }
            )
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ ChallengeList: data.ChallengeDetail });
                } else {
                    this.setState({ ChallengeList: [] });
                }

            })
            .catch(console.log);
    }

    getTheme(cID) {
        fetch(this.state.apiUrl + '/CommonAPI/GetTheme', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": cID,
                "Challenge_ID": null,
                "Start_Index": 1,
                "Max_Rows": 1
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ storyRedirectID: data.ListingDetail[0].Listing_ID, storyRedirect: true });
                }

            })
            .catch(console.log);
    }

    getThemeList(pageNo) {
        fetch(this.state.apiUrl + '/CommonAPI/GetTheme', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": null,
                "Challenge_ID": null,
                "Start_Index": pageNo,
                "Max_Rows": 2
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    let ThemeList = this.state.ThemeList;
                    data.ListingDetail.forEach(function (item, index) {
                        ThemeList.push(item);
                    });

                    this.setState({ ThemeList: ThemeList });
                } else {
                    this.setState({ noMoreTheme: true });
                }

            })
            .catch(console.log);
    }


    scrollToMyRef = () => window.scrollTo(0, this.currentParticipants.current.offsetTop);

    componentDidMount() {
        this.getLatestChallenge(16);
        this.Challenge_IsValidVotingPeriod();
        this.getChallenge();
        this.getThemeList(1);
        const filterValue = getParams(window.location.href);
        if (filterValue.cp) {
            this.scrollToMyRef();
        }
    }

    render() {
        const { currentChallenge } = this.state;
        let voteArray = localStorage.getItem('vcount') ? localStorage.getItem('vcount') : [];
        if (this.state.storyRedirect) {
            return <Redirect to={`/stories?Theme=${this.state.storyRedirectID}`} />
        }
        function NextArrow(props) {
            const { currentSlide, slideCount, className, onClick } = props;

            return (
                <div onClick={onClick}>
                    <button className={"slick-arrow slick-next"} ><img src="./images/slideRight.png" /></button>
                </div>
            );
        }

        function PrevArrow(props) {
            const { currentSlide, slideCount, className, onClick } = props;

            return (
                <div onClick={onClick}>
                    <button className={"slick-arrow slick-prev"} ><img src="./images/slideLeft.png" /></button>
                </div>
            );
        }
        const settings1 = {
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />
        };
        var WinnerAnnouncement = false;
        const now = moment();

        if (moment(currentChallenge.Challenge_AnnouncementStartDate) < now && moment(currentChallenge.Challenge_AnnouncementEndDate) > now) {
            WinnerAnnouncement = true;
        } else {
            WinnerAnnouncement = false;
        }

        return (
            <div className="Challenge">
                <CountdownBanner />
                { currentChallenge && <div className="container-fluid event-banner">
                    <div className="row">
                        <div className="col-md-12 text-center py-5 text-light text-Gotham">
                            <h3 className="m-0 font-Gotham-Bold"><span className="text-uppercase">{currentChallenge.Challenge_Title}</span></h3>
                            <p className="my-2">({moment(currentChallenge.Challenge_StartDate).format('DD MMM')} {moment(currentChallenge.Challenge_StartDate).format('YYYY')} - {moment(currentChallenge.Challenge_EndDate).format('DD MMM')} {moment(currentChallenge.Challenge_EndDate).format('YYYY')})</p>
                            <h5>Result Release on {moment(currentChallenge.Challenge_AnnouncementStartDate).format('DD MMM YYYY')}</h5>
                        </div>
                    </div>
                </div>}
                { currentChallenge && <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 py-5">
                            {/* <img src="images/slice/4.event/titles/Group 393.png" className="img-fluid" /> */}
                            <div className="text-light font-weight-bold text-center text-Gotham" style={{ backgroundColor: '#033369', transform: 'rotate(-2deg)', maxWidth: '350px', padding: '10px 0' }}>
                                <span>ONGOING CHALLENGE</span>
                            </div>
                        </div>
                    </div>

                    <div className="container pb-md-5">
                        <div className="row">
                            <div className="col-md-12 slider">
                                <div className="d-md-flex flex-row">
                                    <div className="pr-md-3 slider-item"><img src={currentChallenge.Challenge_Image} className="img-fluid w-100" /></div>
                                    <div className="py-3 py-md-0 slider-item">
                                        <h3 className="font-weight-bold color_113F70">{currentChallenge.Challenge_Title}</h3>
                                        {/* <p>Name: Lorem Ipsum</p> */}
                                        <p dangerouslySetInnerHTML={{ __html: currentChallenge.Challenge_Description }}></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>}
                {this.state.WinnerList && this.state.WinnerList.length > 0 && WinnerAnnouncement && <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 py-5">
                            {/* <img src="images/slice/4.event/titles/Group 393.png" className="img-fluid" /> */}
                            <div className="text-light font-weight-bold text-center text-Gotham" style={{ backgroundColor: '#033369', transform: 'rotate(-2deg)', maxWidth: '350px', padding: '10px 0' }}>
                                <span>WINNER ANNOUNCEMENT</span><br />
                                {moment(currentChallenge.Challenge_AnnouncementStartDate).format('DD MMM YYYY')} to {moment(currentChallenge.Challenge_AnnouncementEndDate).format('DD MMM YYYY')}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-3 theme-selection">
                            <ul className="d-flex flex-row justify-content-center m-0">
                                <li className={this.state.winnerFilter === 16 ? 'active' : ''} onClick={() => this.getLatestChallenge(16)}>YEP</li>
                                <li className={this.state.winnerFilter === 17 ? 'active' : ''} onClick={() => this.getLatestChallenge(17)}>YEP GO</li>
                            </ul>
                        </div>
                    </div>
                    <div className="container pb-md-5">
                        <div className="row">
                            <div className="col-md-12 slider">
                                <div className="d-flex justify-content-center align-items-center">
                                    {this.state.WinnerList.map((data, index) => {
                                        return (
                                            <div key={index} className="d-md-flex flex-row">
                                                <div className="pr-md-3 slider-item"><img src={data.Story_Image} className="img-fluid w-100" /></div>
                                                <div className="py-3 py-md-0 slider-item">
                                                    <h3 className="font-weight-bold color_113F70" style={{ wordBreak: 'break-word' }}>{data.Story_Title}</h3>
                                                    {/* <p>Name: {data.Contact_Name}</p>

                                                    <p>
                                                        <small>{data.Trip_StartDate}&nbsp; to &nbsp;{data.Trip_EndDate}</small>
                                                    </p> */}
                                                    <p dangerouslySetInnerHTML={{ __html: data.Story_Description }}></p>
                                                    <Link to={`/StoryDetails/${data.Story_ID}`} className="btn btn-outline-primary">View Story</Link>
                                                </div>
                                            </div>
                                        );
                                    })

                                    }
                                </div >
                            </div>
                        </div>
                    </div>
                </div>}
                {this.state.WinnerList && this.state.WinnerList.length <= 0 && WinnerAnnouncement &&
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12 py-5">
                                {/* <img src="images/slice/4.event/titles/Group 393.png" className="img-fluid" /> */}
                                <div className="text-light font-weight-bold text-center" style={{ backgroundColor: '#033369', transform: 'rotate(-2deg)', maxWidth: '350px', padding: '10px 0' }}>
                                    <span>WINNER ANNOUNCEMENT</span><br />
                                    {moment(currentChallenge.Challenge_AnnouncementStartDate).format('DD MMM YYYY')} to {moment(currentChallenge.Challenge_AnnouncementEndDate).format('DD MMM YYYY')}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mb-3 theme-selection">
                                <ul className="d-flex flex-row justify-content-center m-0">
                                    <li className={this.state.winnerFilter === 16 ? 'active' : ''} onClick={() => this.getLatestChallenge(16)}>YEP</li>
                                    <li className={this.state.winnerFilter === 17 ? 'active' : ''} onClick={() => this.getLatestChallenge(17)}>YEP GO</li>
                                </ul>
                            </div>
                        </div>
                        <div className="container pb-md-5">
                            <div className="row">
                                <div className="col-md-12 text-center mt-3">

                                    Winner announcement date: {moment(currentChallenge.Challenge_AnnouncementStartDate).format('DD MMM YYYY')} to {moment(currentChallenge.Challenge_AnnouncementEndDate).format('DD MMM YYYY')}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="container-fluid" ref={this.currentParticipants}>
                    <div className="row">
                        {/* <div className="col-md-12 py-5">
                            <img src="images/slice/4.event/titles/titles/currentpart.png" className="img-fluid" />
                        </div> */}
                        <div className="col-md-12 py-5">
                            {/* <img src="images/slice/4.event/titles/Group 393.png" className="img-fluid" /> */}
                            <div className="text-light font-weight-bold text-center text-Gotham" style={{ backgroundColor: '#033369', transform: 'rotate(-2deg)', maxWidth: '350px', padding: '10px 0' }}>
                                <span>CURRENT PARTICIPANTS</span>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-3 theme-selection">
                            <ul className="d-flex flex-row justify-content-center m-0">
                                <li className={this.state.filterProject === 16 ? 'active' : ''} onClick={() => this.ChangeProject(16)}>YEP</li>
                                <li className={this.state.filterProject === 17 ? 'active' : ''} onClick={() => this.ChangeProject(17)}>YEP GO</li>
                            </ul>
                        </div>
                    </div>
                    {this.state.StoryList.length > 0 && <div className="container current_participant">
                        <div className="row">
                            {/* <div className="col-md-12 slider2 pb-md-5"> */}
                            {/* <Slider {...settings2} className="d-flex justify-content-center align-items-center"> */}
                            {this.state.StoryList.map((data, index) => {
                                return (
                                    <div key={index} className="col-6 col-md-3 pb-3">
                                        <div className="item-img bg-light d-flex align-items-center">
                                            <Link to={`/StoryDetails/${data.Story_ID}`}><img src={data.Story_Image} alt={data.Story_Title} className="img-fluid" /></Link>
                                            {/* <div className="position-absolute masonry-item-tag winner-tag">
                                                Challenge Winner!
                                            </div> */}
                                        </div>
                                        <div className="py-3 py-md-0 m-2">
                                            <p className="m-0 font-weight-bold color_113F70 text-truncate py-2" style={{ maxWidth: '300px' }}>{data.Story_Title}</p>
                                            <small><div className="text-truncate mb-2" style={{ maxWidth: '300px' }}>{data.Story_Description}</div></small>

                                            {!voteArray.includes(data.Story_ID) && this.state.isVotingPeriod && <button className="btn btn-outline-primary w-100" onClick={(e) => this.vote(e, data.Story_ID)}>Vote</button>}
                                            {voteArray.includes(data.Story_ID) && this.state.isVotingPeriod && <button className="btn btn-outline-primary w-100" disabled="true">Vote</button>}
                                        </div>
                                    </div>
                                );
                            })

                            }
                            {/* </Slider> */}
                            {/* </div> */}
                        </div>
                    </div>}
                    {this.state.StoryList.length <= 0 && <div className="container current_participant">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                No Participant!
                           </div>
                        </div>
                    </div>}
                </div>

                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-md-12 py-5">
                            <img src="images/slice/4.event/titles/Group 467.png" className="img-fluid" />
                        </div> */}
                        <div className="col-md-12 py-5">
                            {/* <img src="images/slice/4.event/titles/Group 393.png" className="img-fluid" /> */}
                            <div className="text-light font-weight-bold text-center text-Gotham" style={{ backgroundColor: '#033369', transform: 'rotate(-2deg)', maxWidth: '350px', padding: '10px 0' }}>
                                <span>COLLECTION BY THEME</span>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-md-12 mb-3 theme-selection">
                            <ul className="d-flex flex-row justify-content-center m-0">
                                <li>Theme 1</li>
                                <li>Theme 2</li>
                                <li>Theme 3</li>
                                <li>Theme 4</li>
                            </ul>
                        </div>
                    </div> */}
                    <div className="container pb-md-5">
                        <div className="row">
                            {this.state.ThemeList.map((data, index) => {
                                return (
                                    <div key={index} className="col-md-6 mt-3 cursor_pointer" onClick={() => this.getTheme(data.Listing_ID)}>
                                        <h4 className="font-weight-bold color_113F70">#{data.Listing_Name}</h4>
                                        <div className="position-relative overflow-hidden">
                                            <img src={data.Listing_Icon} alt={data.Listing_Name} className="img-fluid w-100" />
                                            <div className="position-absolute masonry-item-tag color_113F70 font-weight-bold">
                                                {data.Story_Count} STORIES
                                        </div>
                                        </div>
                                    </div>

                                );
                            })

                            }
                        </div>
                        <div className="row mt-5">
                            <div className="col-md-12 d-flex justify-content-center">
                                {!this.state.noMoreTheme && <button className="btn btn-outline-primary" onClick={this.ViewMore}>VIEW MORE</button>}
                                {this.state.noMoreTheme && <span>No more theme</span>}
                            </div>
                        </div>
                    </div>

                </div>
                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-md-12 py-5">
                            <img src="images/slice/4.event/titles/Group 543.png" className="img-fluid" />
                        </div> */}
                        <div className="col-md-12 py-5">
                            {/* <img src="images/slice/4.event/titles/Group 393.png" className="img-fluid" /> */}
                            <div className="text-light font-weight-bold text-center text-Gotham" style={{ backgroundColor: '#033369', transform: 'rotate(-2deg)', maxWidth: '350px', padding: '10px 0' }}>
                                <span>FAQ</span>
                            </div>
                        </div>
                    </div>
                    <div className="container faq h-100">
                        <div className="row">
                            <div className="col-md-12">
                                <Accordion defaultActiveKey="0">
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} className="color_113F70 font-weight-bold" eventKey="0">
                                            Who can participate?
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="0">
                                            <Card.Body>
                                                Only YEP or YEP-GO teams who submit stories during the challenge participation dates can participate.
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} className="color_113F70 font-weight-bold" eventKey="1">
                                            How can I participate?
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body>
                                                You can participate when submitting your story. You will be directed to select a photo best suited for the theme(s) and include a relevant short caption. Your submission will automatically be enrolled into the challenge once your story is approved and based on the time period of submission.

                                        </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} className="color_113F70 font-weight-bold" eventKey="2">
                                            How do I get votes?
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="2">
                                            <Card.Body>
                                                You can share your submission to your friends and families to garner votes. Each IP address is allocated to 1 vote across all themes.

                                        </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} className="color_113F70 font-weight-bold" eventKey="3">
                                            How do I vote?

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="3">
                                            <Card.Body>
                                                A vote button will appear on each submission. You can vote anytime during the voting period.

                                        </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} className="color_113F70 font-weight-bold" eventKey="4">
                                            How are the winners selected?
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="4">
                                            <Card.Body>
                                                1 winner will be selected per theme for YEP and YEP-GO each. Submissions will be assessed on a set of criteria such as number of votes, relevance of caption, relevance to theme and quality of submission. Winners will be notified via email approximately 1 month after voting period has ended.
                                        </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                    <Card>
                                        <Accordion.Toggle as={Card.Header} className="color_113F70 font-weight-bold" eventKey="5">
                                            I have questions still unanswered.
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="5">
                                            <Card.Body>
                                                Please reach out to us at <a href="mailto:yep_enquiries@nyc.gov.sg">yep_enquiries@nyc.gov.sg</a>. We will get back to you shortly.
                                        </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
                <Toast className="position-fixed" style={{ top: 0, left: '50%', transform: 'translate(-50%, 0)', zIndex: 999 }} onClose={this.toggleAlertBox} show={this.state.alertBox} animation={true} delay={2000} autohide>
                    <Toast.Header>
                        Thanks for your support!
                </Toast.Header>
                    <Toast.Body>
                        <img src="./images/checked.png" className="icons-md" /> You have submitted a vote to this story
                </Toast.Body>
                </Toast>
            </div>
        );
    }
}

export default Challenge;

